import { Component, computed, inject, input, ChangeDetectionStrategy } from '@angular/core';
import { ToolbarBridgeService } from './toolbar-bridge.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: '[tpToolbar]',
  imports: [CommonModule],
  templateUrl: './tp-toolbar.html',
  styleUrl: './tp-toolbar.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  host: {
    '[class.show]': 'hasContent',
  },
})
export class TpToolbar {
  id = input.required<string>();
  bridge = inject(ToolbarBridgeService);

  get hasContent(): boolean {
    return this.bridge.hasContent(this.id())();
  }
}
